import React, { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Sidebar from './Sidebar';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
    const { user } = useAuth();
    const [sidebarWidth, setSidebarWidth] = useState(70);

    if (!user) {
        // For non-authenticated users, just render children (like Login page)
        return <>{children}</>;
    }

    // Default layout with sidebar
    return (
        <Box h="100vh" w="100vw" bg="gray.50" overflow="hidden">
            <Flex h="100vh" w="100%">
                <Sidebar onWidthChange={setSidebarWidth} />
                <Box
                    as="main"
                    flex="1"
                    w="100%"
                    h="100vh"
                    overflowY="auto"
                    overflowX="hidden"
                    marginLeft={{ base: "0", md: `${sidebarWidth}px` }}
                    transition="margin-left 0.3s ease"
                    pt={{ base: "56px", md: "44px" }}
                    pb={0}
                >
                    {children}
                </Box>
            </Flex>
        </Box>
    );
};

export default Layout;
